// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1U9Kh","title":"Info_title__3eRgD","links":"Info_links__1p3Hc","link":"Info_link__3p1qq","logo":"Info_logo__3Lxba"};